// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback } from 'react';

// ── Static index stock data ──────────────────────────────────────────────────

const NIFTY50 = [
  { symbol: 'ADANIENT',   token: '25',    prevClose: 2350.50 },
  { symbol: 'ADANIPORTS', token: '15083', prevClose: 1150.75 },
  { symbol: 'APOLLOHOSP', token: '157',   prevClose: 6850.20 },
  { symbol: 'ASIANPAINT', token: '236',   prevClose: 2450.80 },
  { symbol: 'AXISBANK',   token: '5900',  prevClose: 1125.30 },
  { symbol: 'BAJAJ-AUTO', token: '16669', prevClose: 8950.40 },
  { symbol: 'BAJFINANCE', token: '317',   prevClose: 6850.60 },
  { symbol: 'BAJAJFINSV', token: '16675', prevClose: 1580.25 },
  { symbol: 'BEL',        token: '383',   prevClose: 285.90  },
  { symbol: 'BPCL',       token: '526',   prevClose: 295.45  },
  { symbol: 'BHARTIARTL', token: '2714',  prevClose: 1625.70 },
  { symbol: 'BRITANNIA',  token: '547',   prevClose: 4850.30 },
  { symbol: 'CIPLA',      token: '694',   prevClose: 1450.85 },
  { symbol: 'COALINDIA',  token: '5215',  prevClose: 425.60  },
  { symbol: 'DRREDDY',    token: '881',   prevClose: 1185.40 },
  { symbol: 'EICHERMOT',  token: '910',   prevClose: 4750.90 },
  { symbol: 'GRASIM',     token: '1232',  prevClose: 2650.35 },
  { symbol: 'HCLTECH',    token: '7229',  prevClose: 1895.20 },
  { symbol: 'HDFCBANK',   token: '1333',  prevClose: 1750.45 },
  { symbol: 'HDFCLIFE',   token: '467',   prevClose: 685.30  },
  { symbol: 'HEROMOTOCO', token: '1348',  prevClose: 4650.80 },
  { symbol: 'HINDALCO',   token: '1363',  prevClose: 645.25  },
  { symbol: 'HINDUNILVR', token: '1394',  prevClose: 2350.60 },
  { symbol: 'ICICIBANK',  token: '4963',  prevClose: 1185.90 },
  { symbol: 'ITC',        token: '1660',  prevClose: 465.75  },
  { symbol: 'INDUSINDBK', token: '5258',  prevClose: 985.40  },
  { symbol: 'INFY',       token: '1594',  prevClose: 1850.25 },
  { symbol: 'JSWSTEEL',   token: '11723', prevClose: 925.60  },
  { symbol: 'KOTAKBANK',  token: '1922',  prevClose: 1785.35 },
  { symbol: 'LT',         token: '11483', prevClose: 3650.80 },
  { symbol: 'M&M',        token: '2031',  prevClose: 2950.45 },
  { symbol: 'MARUTI',     token: '10999', prevClose: 12850.90},
  { symbol: 'NTPC',       token: '11630', prevClose: 385.25  },
  { symbol: 'NESTLEIND',  token: '17963', prevClose: 2285.60 },
  { symbol: 'ONGC',       token: '2475',  prevClose: 285.35  },
  { symbol: 'POWERGRID',  token: '14977', prevClose: 325.80  },
  { symbol: 'RELIANCE',   token: '2885',  prevClose: 1285.45 },
  { symbol: 'SBILIFE',    token: '21808', prevClose: 1585.70 },
  { symbol: 'SBIN',       token: '3045',  prevClose: 825.30  },
  { symbol: 'SUNPHARMA',  token: '3351',  prevClose: 1785.90 },
  { symbol: 'TCS',        token: '11536', prevClose: 4150.25 },
  { symbol: 'TATACONSUM', token: '3432',  prevClose: 1085.60 },
  { symbol: 'TATAMOTORS', token: '3456',  prevClose: 785.35  },
  { symbol: 'TATAPOWER',  token: '3426',  prevClose: 425.80  },
  { symbol: 'TATASTEEL',  token: '3499',  prevClose: 165.45  },
  { symbol: 'TECHM',      token: '13538', prevClose: 1685.70 },
  { symbol: 'TITAN',      token: '3506',  prevClose: 3450.25 },
  { symbol: 'ULTRACEMCO', token: '11532', prevClose: 11250.60},
  { symbol: 'WIPRO',      token: '3787',  prevClose: 585.90  },
];

// BSE Sensex 30 — scrip codes are the WebSocket tokens for BSE exchange
const SENSEX30 = [
  { symbol: 'RELIANCE',   token: '500325', prevClose: 1285.00 },
  { symbol: 'TCS',        token: '532540', prevClose: 4150.00 },
  { symbol: 'HDFCBANK',   token: '500180', prevClose: 1750.00 },
  { symbol: 'INFY',       token: '500209', prevClose: 1850.00 },
  { symbol: 'HINDUNILVR', token: '500696', prevClose: 2350.00 },
  { symbol: 'ICICIBANK',  token: '532174', prevClose: 1185.00 },
  { symbol: 'BHARTIARTL', token: '532454', prevClose: 1625.00 },
  { symbol: 'BAJFINANCE', token: '500034', prevClose: 6850.00 },
  { symbol: 'AXISBANK',   token: '532215', prevClose: 1125.00 },
  { symbol: 'KOTAKBANK',  token: '500247', prevClose: 1785.00 },
  { symbol: 'WIPRO',      token: '507685', prevClose: 585.00  },
  { symbol: 'LT',         token: '500510', prevClose: 3650.00 },
  { symbol: 'HCLTECH',    token: '532281', prevClose: 1895.00 },
  { symbol: 'ONGC',       token: '500312', prevClose: 285.00  },
  { symbol: 'ITC',        token: '500875', prevClose: 465.00  },
  { symbol: 'SBIN',       token: '500112', prevClose: 825.00  },
  { symbol: 'SUNPHARMA',  token: '524715', prevClose: 1785.00 },
  { symbol: 'MARUTI',     token: '532500', prevClose: 12850.00},
  { symbol: 'TATACONSUM', token: '500800', prevClose: 1085.00 },
  { symbol: 'TATAMOTORS', token: '500570', prevClose: 785.00  },
  { symbol: 'M&M',        token: '500520', prevClose: 2950.00 },
  { symbol: 'POWERGRID',  token: '532898', prevClose: 325.00  },
  { symbol: 'NTPC',       token: '532555', prevClose: 385.00  },
  { symbol: 'TITAN',      token: '500114', prevClose: 3450.00 },
  { symbol: 'BAJAJFINSV', token: '532978', prevClose: 1580.00 },
  { symbol: 'INDUSINDBK', token: '532187', prevClose: 985.00  },
  { symbol: 'ASIANPAINT', token: '500820', prevClose: 2450.00 },
  { symbol: 'NESTLEIND',  token: '500790', prevClose: 2285.00 },
  { symbol: 'DRREDDY',    token: '500124', prevClose: 1185.00 },
  { symbol: 'ULTRACEMCO', token: '532538', prevClose: 11250.00},
];

// ── Empty trade row factory ──────────────────────────────────────────────────

const emptyRow = () => ({
  id: Math.random().toString(36).slice(2),
  symbol: null,        // { token, tradingSymbol, instrumentId, lotSize }
  qty: '1',
  product: 'MIS',
  orderType: 'LIMIT',
  price: '',
  searchQuery: '',
  searchResults: [],
  searching: false,
});

// ── Helper ───────────────────────────────────────────────────────────────────

const fmt2 = (v) => (v != null ? parseFloat(v).toFixed(2) : '—');

// ── Component ────────────────────────────────────────────────────────────────

const EquityTradingTab = ({
  exchange,           // 'NSE' | 'BSE'
  livePrices,         // { 'NSE|TOKEN': { ltp, pc, v, h, l, c } }
  aliceBlueWS,
  userSession,
  userId,
  api,
  isMasterUser,
  userGroups,
  tradeBook,
  orderBook,
}) => {
  const indexSymbols = exchange === 'NSE' ? NIFTY50 : SENSEX30;

  // ── Local state ───────────────────────────────────────────────────────────

  const [tradeRows, setTradeRows] = useState(() => Array(5).fill(null).map(emptyRow));
  const [posView, setPosView] = useState('positions'); // 'positions' | 'trades' | 'orders'
  const [popup, setPopup] = useState({ show: false, msg: '', type: 'success' });
  const [confirmModal, setConfirmModal] = useState({ show: false });
  const [equityPositions, setEquityPositions] = useState([]);
  const [equityTrades, setEquityTrades]      = useState([]);
  const [equityOrders, setEquityOrders]      = useState([]);
  const searchTimers = useRef({});
  const posRefTimer  = useRef(null);

  // ── Fetch equity-specific positions / orders / trades ────────────────────

  const fetchEquityData = useCallback(async () => {
    try {
      const [posRes, tradeRes, orderRes] = await Promise.allSettled([
        api.get('/portfolio/positions'),
        api.get('/portfolio/tradebook'),
        api.get('/orders/orderbook'),
      ]);
      if (posRes.status === 'fulfilled' && posRes.value.data?.success) {
        const all = posRes.value.data.data || [];
        setEquityPositions(all.filter(p => p.exchange === exchange));
      }
      if (tradeRes.status === 'fulfilled' && tradeRes.value.data?.success) {
        const all = tradeRes.value.data.data || [];
        setEquityTrades(all.filter(t => t.exchange === exchange));
      }
      if (orderRes.status === 'fulfilled' && orderRes.value.data?.success) {
        const all = orderRes.value.data.data || [];
        setEquityOrders(all.filter(o => o.exchange === exchange));
      }
    } catch { /* silent */ }
  }, [api, exchange]);

  useEffect(() => {
    fetchEquityData();
    posRefTimer.current = setInterval(fetchEquityData, 15000);
    return () => clearInterval(posRefTimer.current);
  }, [fetchEquityData]);

  // ── Subscribe index symbols to WebSocket on mount / exchange change ───────

  useEffect(() => {
    if (!aliceBlueWS) return;
    const instruments = indexSymbols.map(s => ({ exchange, token: s.token }));
    aliceBlueWS.subscribe(instruments);
  }, [exchange, aliceBlueWS]); // eslint-disable-line

  // ── Unsubscribe trade-row symbols when component unmounts ─────────────────

  useEffect(() => {
    return () => {
      if (!aliceBlueWS) return;
      const tokens = tradeRows
        .filter(r => r.symbol)
        .map(r => ({ exchange, token: r.symbol.token }));
      if (tokens.length) aliceBlueWS.unsubscribe?.(tokens);
    };
  }, []); // eslint-disable-line

  // ── Helpers ───────────────────────────────────────────────────────────────

  const getLTP = useCallback((token) => {
    const key = `${exchange}|${token}`;
    const d = livePrices[key];
    return d?.ltp || d?.lp || null;
  }, [livePrices, exchange]);

  const getChangePct = useCallback((token, prevClose) => {
    const key = `${exchange}|${token}`;
    const d = livePrices[key];
    if (d?.pc !== undefined) return parseFloat(d.pc);
    const ltp = d?.ltp || d?.lp;
    if (ltp && prevClose && prevClose > 0) return ((ltp - prevClose) / prevClose) * 100;
    return null;
  }, [livePrices, exchange]);

  const showPopup = (msg, type = 'success') => {
    setPopup({ show: true, msg, type });
    setTimeout(() => setPopup({ show: false, msg: '', type: 'success' }), 3500);
  };

  // ── Market Watch sorted list ──────────────────────────────────────────────

  const sortedSymbols = [...indexSymbols].sort((a, b) => {
    const ca = getChangePct(a.token, a.prevClose) ?? -Infinity;
    const cb = getChangePct(b.token, b.prevClose) ?? -Infinity;
    return cb - ca;
  });

  const gainers = sortedSymbols.filter(s => (getChangePct(s.token, s.prevClose) ?? 0) >= 0);
  const losers  = sortedSymbols.filter(s => (getChangePct(s.token, s.prevClose) ?? 0) < 0);

  // ── Add stock to a trade row (first empty, else first row) ────────────────

  const addToTradePanel = (stock) => {
    setTradeRows(prev => {
      const emptyIdx = prev.findIndex(r => !r.symbol);
      const targetIdx = emptyIdx >= 0 ? emptyIdx : 0;
      const updated = [...prev];
      updated[targetIdx] = {
        ...updated[targetIdx],
        symbol: {
          token: stock.token,
          tradingSymbol: stock.symbol,
          instrumentId: stock.token,
          lotSize: 1,
        },
        searchQuery: stock.symbol,
      };
      // Subscribe new token
      if (aliceBlueWS) aliceBlueWS.subscribe([{ exchange, token: stock.token }]);
      return updated;
    });
  };

  // ── Trade row symbol search ────────────────────────────────────────────────

  const handleRowSearch = (rowId, query) => {
    setTradeRows(prev => prev.map(r =>
      r.id === rowId ? { ...r, searchQuery: query, symbol: query ? r.symbol : null } : r
    ));
    if (searchTimers.current[rowId]) clearTimeout(searchTimers.current[rowId]);
    if (!query.trim()) {
      setTradeRows(prev => prev.map(r => r.id === rowId ? { ...r, searchResults: [] } : r));
      return;
    }
    searchTimers.current[rowId] = setTimeout(async () => {
      setTradeRows(prev => prev.map(r => r.id === rowId ? { ...r, searching: true } : r));
      try {
        const res = await api.get(
          `/symbols/search?q=${encodeURIComponent(query.trim())}&exchange=${exchange}&limit=8`,
          { headers: { Authorization: `Bearer ${userSession}` } }
        );
        const results = res.data.success ? (res.data.data || []) : [];
        setTradeRows(prev => prev.map(r =>
          r.id === rowId ? { ...r, searchResults: results, searching: false } : r
        ));
      } catch {
        setTradeRows(prev => prev.map(r => r.id === rowId ? { ...r, searching: false } : r));
      }
    }, 300);
  };

  const selectRowSymbol = (rowId, sym) => {
    const token = sym.instrumentId || sym.instrument_id;
    if (aliceBlueWS) aliceBlueWS.subscribe([{ exchange, token }]);
    setTradeRows(prev => prev.map(r =>
      r.id === rowId ? {
        ...r,
        symbol: { token, tradingSymbol: sym.tradingSymbol, instrumentId: token, lotSize: sym.lotSize || 1 },
        searchQuery: sym.tradingSymbol,
        searchResults: [],
      } : r
    ));
  };

  const updateRow = (rowId, field, value) => {
    setTradeRows(prev => prev.map(r => r.id === rowId ? { ...r, [field]: value } : r));
  };

  const removeRow = (rowId) => {
    setTradeRows(prev => {
      const row = prev.find(r => r.id === rowId);
      if (row?.symbol && aliceBlueWS) aliceBlueWS.unsubscribe?.([{ exchange, token: row.symbol.token }]);
      return prev.map(r => r.id === rowId ? emptyRow() : r);
    });
  };

  // ── Order Placement ───────────────────────────────────────────────────────

  const placeEquityOrder = async (row, action) => {
    if (!row.symbol) { showPopup('Select a symbol first', 'error'); return; }
    const qty = parseInt(row.qty);
    if (!qty || qty <= 0) { showPopup('Enter valid quantity', 'error'); return; }
    const ltp = getLTP(row.symbol.token) || 0;
    const price = row.orderType === 'MARKET' ? 0 : (parseFloat(row.price) || ltp);
    if (row.orderType === 'LIMIT' && price <= 0) { showPopup('Enter valid price for LIMIT order', 'error'); return; }

    // Confirmation modal
    const confirmed = await new Promise(resolve => {
      setConfirmModal({
        show: true,
        action,
        symbol: row.symbol.tradingSymbol,
        qty,
        price,
        ltp,
        orderType: row.orderType,
        product: row.product,
        onConfirm: (p, q) => { setConfirmModal({ show: false }); resolve({ price: p, qty: q }); },
        onCancel:  ()     => { setConfirmModal({ show: false }); resolve(null); },
      });
    });
    if (!confirmed) return;

    try {
      const payload = {
        exchange,
        tradingSymbol: row.symbol.tradingSymbol,
        instrumentId:  row.symbol.instrumentId,
        transactionType: action,
        quantity: confirmed.qty,
        price:    row.orderType === 'MARKET' ? 0 : (confirmed.price || ltp),
        ltp,
        orderType:  row.orderType,
        validity:   'DAY',
        product:    row.product,
        orderComplexity: 'REGULAR',
        deviceId: '123',
        userId,
      };
      const res = await api.post('/orders/place', payload);
      if (res.data.success) {
        showPopup(`${action} order placed for ${row.symbol.tradingSymbol}`, 'success');
      setTimeout(fetchEquityData, 1500); // refresh positions after order
      } else {
        showPopup(`Order failed: ${res.data.error || 'Unknown error'}`, 'error');
      }
    } catch (err) {
      showPopup(`Order error: ${err.message}`, 'error');
    }
  };

  // ── Use locally fetched equity data ──────────────────────────────────────

  const filteredPositions = equityPositions;
  const filteredTrades    = equityTrades;
  const filteredOrders    = equityOrders;

  // ── Render ────────────────────────────────────────────────────────────────

  return (
    <div className="flex flex-col gap-2">

      {/* ── Top popup ─────────────────────────────────────────── */}
      {popup.show && (
        <div className={`fixed top-4 right-4 z-50 px-4 py-2 rounded shadow-lg text-white text-sm font-semibold ${
          popup.type === 'success' ? 'bg-green-600' : 'bg-red-600'
        }`}>
          {popup.msg}
        </div>
      )}

      {/* ── Main row: Market Watch + Trade Panel ──────────────── */}
      <div className="flex gap-2 items-stretch">

        {/* ── LEFT: Market Watch ──────────────────────────────── */}
        <div className="flex-none" style={{ width: '30%' }}>
          <div className="bg-white rounded-lg shadow-sm border overflow-hidden h-full">
            {/* Header */}
            <div className={`px-3 py-1.5 flex items-center justify-between ${
              exchange === 'NSE' ? 'bg-sky-600' : 'bg-orange-600'
            }`}>
              <span className="text-xs font-bold text-white">
                {exchange === 'NSE' ? 'Nifty 50' : 'Sensex 30'} — Market Watch
              </span>
              <span className="text-[9px] text-white opacity-80">{exchange}</span>
            </div>

            {/* Column headers */}
            <div className="grid grid-cols-12 bg-gray-100 border-b text-[9px] font-semibold text-gray-600 px-1 py-0.5">
              <div className="col-span-4">Symbol</div>
              <div className="col-span-3 text-right">LTP</div>
              <div className="col-span-2 text-right">%Chg</div>
              <div className="col-span-3 text-right">B / S</div>
            </div>

            <div className="overflow-y-auto" style={{ maxHeight: 480 }}>
              {/* Gainers */}
              {gainers.length > 0 && (
                <>
                  <div className="bg-green-50 px-2 py-0.5 text-[9px] font-bold text-green-700 border-b border-green-100">
                    Gainers ({gainers.length})
                  </div>
                  {gainers.map(s => <MarketRow key={s.token} stock={s} exchange={exchange} getLTP={getLTP} getChangePct={getChangePct} addToTradePanel={addToTradePanel} placeDirectOrder={placeEquityOrder} isGainer />)}
                </>
              )}
              {/* Losers */}
              {losers.length > 0 && (
                <>
                  <div className="bg-red-50 px-2 py-0.5 text-[9px] font-bold text-red-700 border-b border-red-100">
                    Losers ({losers.length})
                  </div>
                  {[...losers].reverse().map(s => <MarketRow key={s.token} stock={s} exchange={exchange} getLTP={getLTP} getChangePct={getChangePct} addToTradePanel={addToTradePanel} placeDirectOrder={placeEquityOrder} />)}
                </>
              )}
            </div>
          </div>
        </div>

        {/* ── RIGHT: Quick Trade Panel ─────────────────────────── */}
        <div className="flex-1 min-w-0">
          <div className="bg-white rounded-lg shadow-sm border overflow-hidden h-full">
            {/* Header */}
            <div className={`px-3 py-1.5 flex items-center justify-between ${
              exchange === 'NSE' ? 'bg-sky-600' : 'bg-orange-600'
            }`}>
              <span className="text-xs font-bold text-white">Quick Trade Entry</span>
              <div className="flex gap-2 items-center">
                <span className="text-[9px] text-white opacity-80">Double-click market row to add</span>
                <button
                  onClick={() => setTradeRows(prev => [...prev, emptyRow()])}
                  className="text-[10px] bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-2 py-0.5 rounded"
                >+ Row</button>
              </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="w-full text-[11px]">
                <thead className="bg-gray-50 border-b">
                  <tr className="text-gray-600 font-semibold text-[10px]">
                    <th className="px-2 py-1 text-left w-[24%]">Symbol</th>
                    <th className="px-1 py-1 text-center w-[9%]">LTP</th>
                    <th className="px-1 py-1 text-center w-[8%]">%Chg</th>
                    <th className="px-1 py-1 text-center w-[8%]">Qty</th>
                    <th className="px-1 py-1 text-center w-[8%]">Product</th>
                    <th className="px-1 py-1 text-center w-[9%]">Order</th>
                    <th className="px-1 py-1 text-center w-[9%]">Price</th>
                    <th className="px-1 py-1 text-center w-[8%]">Buy</th>
                    <th className="px-1 py-1 text-center w-[8%]">Sell</th>
                    <th className="px-1 py-1 text-center w-[4%]"></th>
                  </tr>
                </thead>
                <tbody>
                  {tradeRows.map((row) => {
                    const ltp = row.symbol ? getLTP(row.symbol.token) : null;
                    const pctChg = row.symbol ? (() => {
                      const key = `${exchange}|${row.symbol.token}`;
                      const d = livePrices[key];
                      if (d?.pc !== undefined) return parseFloat(d.pc);
                      return null;
                    })() : null;
                    return (
                      <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                        {/* Symbol search */}
                        <td className="px-2 py-1 relative">
                          <input
                            type="text"
                            value={row.searchQuery}
                            onChange={e => handleRowSearch(row.id, e.target.value)}
                            placeholder="Search symbol…"
                            className="w-full text-[11px] border rounded px-1.5 py-0.5 focus:outline-none focus:ring-1 focus:ring-sky-400"
                          />
                          {row.searchResults.length > 0 && (
                            <div className="absolute left-2 top-full bg-white border rounded shadow-xl z-50 w-48 max-h-36 overflow-y-auto">
                              {row.searchResults.map((sym, i) => (
                                <div
                                  key={i}
                                  onClick={() => selectRowSymbol(row.id, sym)}
                                  className="px-2 py-1 text-[11px] cursor-pointer hover:bg-sky-50 flex justify-between"
                                >
                                  <span className="font-semibold">{sym.tradingSymbol}</span>
                                  <span className="text-gray-400 text-[9px]">{sym.instrumentType}</span>
                                </div>
                              ))}
                            </div>
                          )}
                          {row.searching && (
                            <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[9px] text-gray-400">...</div>
                          )}
                        </td>

                        {/* LTP */}
                        <td className="px-1 py-1 text-center font-bold text-blue-700">
                          {ltp ? ltp.toFixed(2) : '—'}
                        </td>

                        {/* %Chg */}
                        <td className={`px-1 py-1 text-center text-[10px] font-semibold ${
                          pctChg === null ? 'text-gray-400' : pctChg >= 0 ? 'text-green-600' : 'text-red-600'
                        }`}>
                          {pctChg !== null ? `${pctChg >= 0 ? '+' : ''}${pctChg.toFixed(2)}%` : '—'}
                        </td>

                        {/* Qty */}
                        <td className="px-1 py-1 text-center">
                          <input
                            type="number"
                            value={row.qty}
                            onChange={e => updateRow(row.id, 'qty', e.target.value)}
                            className="w-14 text-center text-[11px] border rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-sky-400 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none"
                            min="1"
                          />
                        </td>

                        {/* Product */}
                        <td className="px-1 py-1 text-center">
                          <select
                            value={row.product}
                            onChange={e => updateRow(row.id, 'product', e.target.value)}
                            className="text-[10px] border rounded px-1 py-0.5 bg-white focus:outline-none"
                          >
                            <option value="MIS">MIS</option>
                            <option value="CNC">CNC</option>
                            <option value="NRML">NRML</option>
                          </select>
                        </td>

                        {/* Order type */}
                        <td className="px-1 py-1 text-center">
                          <select
                            value={row.orderType}
                            onChange={e => updateRow(row.id, 'orderType', e.target.value)}
                            className="text-[10px] border rounded px-1 py-0.5 bg-white focus:outline-none"
                          >
                            <option value="LIMIT">LIMIT</option>
                            <option value="MARKET">MARKET</option>
                            <option value="SL">SL</option>
                            <option value="SLM">SLM</option>
                          </select>
                        </td>

                        {/* Price */}
                        <td className="px-1 py-1 text-center">
                          {row.orderType !== 'MARKET' ? (
                            <input
                              type="number"
                              value={row.price || (ltp ? ltp.toFixed(2) : '')}
                              onChange={e => updateRow(row.id, 'price', e.target.value)}
                              placeholder={ltp ? ltp.toFixed(2) : '0.00'}
                              step="0.05"
                              className="w-16 text-center text-[11px] border rounded px-1 py-0.5 focus:outline-none focus:ring-1 focus:ring-sky-400 [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none"
                            />
                          ) : (
                            <span className="text-[10px] text-gray-400">MKT</span>
                          )}
                        </td>

                        {/* Buy */}
                        <td className="px-1 py-1 text-center">
                          <button
                            onClick={() => placeEquityOrder(row, 'BUY')}
                            disabled={!row.symbol}
                            className="px-3 py-1 text-[10px] font-bold bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-40 disabled:cursor-not-allowed"
                          >Buy</button>
                        </td>

                        {/* Sell */}
                        <td className="px-1 py-1 text-center">
                          <button
                            onClick={() => placeEquityOrder(row, 'SELL')}
                            disabled={!row.symbol}
                            className="px-3 py-1 text-[10px] font-bold bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-40 disabled:cursor-not-allowed"
                          >Sell</button>
                        </td>

                        {/* Remove */}
                        <td className="px-1 py-1 text-center">
                          <button
                            onClick={() => removeRow(row.id)}
                            className="text-gray-300 hover:text-red-500 text-[11px] font-bold"
                            title="Clear row"
                          >✕</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ── Bottom: Positions / Orders ───────────────────────── */}
      <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
        {/* Tabs */}
        <div className={`px-3 py-1.5 flex items-center gap-3 ${
          exchange === 'NSE' ? 'bg-sky-600' : 'bg-orange-600'
        }`}>
          {['positions', 'trades', 'orders'].map(mode => (
            <button
              key={mode}
              onClick={() => setPosView(mode)}
              className={`text-[11px] font-semibold capitalize px-3 py-0.5 rounded transition-all ${
                posView === mode ? 'bg-white text-gray-800' : 'text-white opacity-70 hover:opacity-100'
              }`}
            >
              {mode === 'positions' ? `Positions (${filteredPositions.length})` :
               mode === 'trades'    ? `Trades (${filteredTrades.length})` :
                                      `Orders (${filteredOrders.length})`}
            </button>
          ))}
        </div>

        {/* Positions */}
        {posView === 'positions' && (
          filteredPositions.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-[11px]">
                <thead className="bg-gray-50 border-b">
                  <tr className="text-gray-600 font-semibold text-[10px]">
                    <th className="px-3 py-1 text-left">Symbol</th>
                    <th className="px-2 py-1 text-center">Qty</th>
                    <th className="px-2 py-1 text-center">Buy Avg</th>
                    <th className="px-2 py-1 text-center">Sell Avg</th>
                    <th className="px-2 py-1 text-center">LTP</th>
                    <th className="px-2 py-1 text-center">Day P&L</th>
                    <th className="px-2 py-1 text-center">Product</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPositions.map((pos, i) => {
                    const sym    = pos.tradingSymbol || pos.tradingsymbol || pos.symbol || '—';
                    const qty    = pos.netQty ?? pos.netqty ?? pos.qty ?? 0;
                    const buyAvg = pos.netBuyAvgPrice ?? pos.buyavgprice ?? pos.buyAvg ?? 0;
                    const selAvg = pos.netSellAvgPrice ?? pos.sellavgprice ?? pos.sellAvg ?? 0;
                    const ltp    = pos.ltp ?? pos.lastPrice ?? '—';
                    const pnl    = pos.dayPnl ?? pos.realisedprofitloss ?? pos.unrealisedprofitloss ?? 0;
                    const prod   = pos.productType ?? pos.prctyp ?? pos.product ?? '—';
                    return (
                      <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="px-3 py-1 font-semibold text-gray-800">{sym}</td>
                        <td className={`px-2 py-1 text-center font-semibold ${qty >= 0 ? 'text-green-600' : 'text-red-600'}`}>{qty}</td>
                        <td className="px-2 py-1 text-center">{fmt2(buyAvg)}</td>
                        <td className="px-2 py-1 text-center">{fmt2(selAvg)}</td>
                        <td className="px-2 py-1 text-center font-semibold text-blue-700">{ltp}</td>
                        <td className={`px-2 py-1 text-center font-bold ${parseFloat(pnl) >= 0 ? 'text-green-600' : 'text-red-600'}`}>{fmt2(pnl)}</td>
                        <td className="px-2 py-1 text-center text-gray-500">{prod}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-4 text-center text-xs text-gray-400">No {exchange} positions</div>
          )
        )}

        {/* Trades */}
        {posView === 'trades' && (
          filteredTrades.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-[11px]">
                <thead className="bg-gray-50 border-b">
                  <tr className="text-gray-600 font-semibold text-[10px]">
                    <th className="px-3 py-1 text-left">Symbol</th>
                    <th className="px-2 py-1 text-center">Type</th>
                    <th className="px-2 py-1 text-center">Qty</th>
                    <th className="px-2 py-1 text-center">Price</th>
                    <th className="px-2 py-1 text-center">Product</th>
                    <th className="px-2 py-1 text-center">Time</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTrades.map((t, i) => {
                    const tSym  = t.tradingSymbol || t.tradingsymbol || t.symbol || '—';
                    const tType = t.transactionType || t.transactiontype || t.buyorsell || '—';
                    const tQty  = t.quantity || t.qty || t.filledshares || '—';
                    const tPrc  = t.price || t.tradeprice || t.fillprice || 0;
                    const tProd = t.productType || t.prctyp || t.product || '—';
                    const tTime = t.orderTime || t.tradetime || t.time || '—';
                    return (
                      <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="px-3 py-1 font-semibold text-gray-800">{tSym}</td>
                        <td className={`px-2 py-1 text-center font-bold ${tType === 'BUY' ? 'text-green-600' : 'text-red-600'}`}>{tType}</td>
                        <td className="px-2 py-1 text-center">{tQty}</td>
                        <td className="px-2 py-1 text-center">{fmt2(tPrc)}</td>
                        <td className="px-2 py-1 text-center text-gray-500">{tProd}</td>
                        <td className="px-2 py-1 text-center text-gray-400">{tTime}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-4 text-center text-xs text-gray-400">No {exchange} trades today</div>
          )
        )}

        {/* Orders */}
        {posView === 'orders' && (
          filteredOrders.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full text-[11px]">
                <thead className="bg-gray-50 border-b">
                  <tr className="text-gray-600 font-semibold text-[10px]">
                    <th className="px-3 py-1 text-left">Symbol</th>
                    <th className="px-2 py-1 text-center">Type</th>
                    <th className="px-2 py-1 text-center">Qty</th>
                    <th className="px-2 py-1 text-center">Price</th>
                    <th className="px-2 py-1 text-center">Status</th>
                    <th className="px-2 py-1 text-center">Product</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((o, i) => {
                    const oSym    = o.tradingSymbol || o.tradingsymbol || o.symbol || '—';
                    const oType   = o.transactionType || o.transactiontype || o.buyorsell || '—';
                    const oQty    = o.quantity || o.qty || '—';
                    const oPrc    = o.price || 0;
                    const oStatus = o.status || o.orderstatus || '—';
                    const oProd   = o.productType || o.prctyp || o.product || '—';
                    return (
                      <tr key={i} className="border-b border-gray-100 hover:bg-gray-50">
                        <td className="px-3 py-1 font-semibold text-gray-800">{oSym}</td>
                        <td className={`px-2 py-1 text-center font-bold ${oType === 'BUY' ? 'text-green-600' : 'text-red-600'}`}>{oType}</td>
                        <td className="px-2 py-1 text-center">{oQty}</td>
                        <td className="px-2 py-1 text-center">{fmt2(oPrc)}</td>
                        <td className={`px-2 py-1 text-center text-[9px] font-semibold ${
                          oStatus === 'complete' ? 'text-green-600' : oStatus === 'rejected' ? 'text-red-600' : 'text-yellow-600'
                        }`}>{oStatus}</td>
                        <td className="px-2 py-1 text-center text-gray-500">{oProd}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="p-4 text-center text-xs text-gray-400">No {exchange} orders</div>
          )
        )}
      </div>

      {/* ── Confirmation Modal ───────────────────────────────── */}
      {confirmModal.show && (
        <ConfirmModal modal={confirmModal} />
      )}
    </div>
  );
};

// ── MarketRow sub-component ───────────────────────────────────────────────────

const MarketRow = ({ stock, exchange, getLTP, getChangePct, addToTradePanel }) => {
  const ltp      = getLTP(stock.token);
  const changePct = getChangePct(stock.token, stock.prevClose);
  const isPos    = changePct === null ? null : changePct >= 0;

  return (
    <div
      className="grid grid-cols-12 items-center border-b border-gray-100 hover:bg-blue-50 cursor-pointer px-1 py-0.5 group"
      onDoubleClick={() => addToTradePanel(stock)}
      title="Double-click to add to trade panel"
    >
      <div className="col-span-4 text-[10px] font-semibold text-gray-800 truncate">{stock.symbol}</div>
      <div className="col-span-3 text-right text-[10px] font-bold text-blue-700">
        {ltp ? ltp.toFixed(2) : '—'}
      </div>
      <div className={`col-span-2 text-right text-[9px] font-semibold ${
        isPos === null ? 'text-gray-400' : isPos ? 'text-green-600' : 'text-red-600'
      }`}>
        {changePct !== null ? `${isPos ? '+' : ''}${changePct.toFixed(2)}%` : '—'}
      </div>
      <div className="col-span-3 flex justify-end gap-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
        <span className="text-[8px] text-gray-400 self-center mr-0.5">2x→</span>
      </div>
    </div>
  );
};

// ── Confirmation Modal sub-component ─────────────────────────────────────────

const ConfirmModal = ({ modal }) => {
  const [price, setPrice] = useState(modal.price || modal.ltp || 0);
  const [qty, setQty]     = useState(modal.qty || 1);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl shadow-2xl w-72 overflow-hidden border">
        <div className={`px-4 py-3 ${modal.action === 'BUY' ? 'bg-green-600' : 'bg-red-600'}`}>
          <h3 className="text-sm font-bold text-white uppercase tracking-wide">
            {modal.action === 'BUY' ? 'Confirm Buy' : 'Confirm Sell'}
          </h3>
        </div>
        <div className="p-4 space-y-3 text-sm">
          <div className="flex justify-between text-gray-700">
            <span className="font-semibold">{modal.symbol}</span>
            <span className={`font-bold ${modal.action === 'BUY' ? 'text-green-600' : 'text-red-600'}`}>{modal.action}</span>
          </div>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <div>
              <label className="text-gray-500 block mb-0.5">Qty</label>
              <input type="number" value={qty} onChange={e => setQty(parseInt(e.target.value) || 1)} min="1"
                className="w-full border rounded px-2 py-1 text-center font-bold focus:outline-none focus:ring-1 focus:ring-blue-400" />
            </div>
            <div>
              <label className="text-gray-500 block mb-0.5">Price {modal.orderType === 'MARKET' ? '(Market)' : ''}</label>
              {modal.orderType !== 'MARKET' ? (
                <input type="number" value={price} onChange={e => setPrice(parseFloat(e.target.value) || 0)} step="0.05"
                  className="w-full border rounded px-2 py-1 text-center font-bold focus:outline-none focus:ring-1 focus:ring-blue-400" />
              ) : (
                <div className="border rounded px-2 py-1 text-center text-gray-400 bg-gray-50">MARKET</div>
              )}
            </div>
          </div>
          <div className="flex gap-2 text-[10px] text-gray-500">
            <span>LTP: ₹{modal.ltp?.toFixed(2)}</span>
            <span>·</span>
            <span>{modal.product}</span>
            <span>·</span>
            <span>{modal.orderType}</span>
          </div>
        </div>
        <div className="flex gap-2 px-4 pb-4">
          <button
            onClick={() => modal.onConfirm(price, qty)}
            className={`flex-1 py-2 rounded font-bold text-white text-sm ${
              modal.action === 'BUY' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'
            }`}
          >
            {modal.action}
          </button>
          <button
            onClick={() => modal.onCancel()}
            className="flex-1 py-2 rounded font-semibold text-gray-700 bg-gray-200 hover:bg-gray-300 text-sm"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EquityTradingTab;
